import classNames from 'classnames';
import { CSSProperties } from 'react';
import styles from './AnimatedDigit.module.scss';

export type AnimatedDigitProps = {
  value: number;
  delay?: number;
} & JSX.IntrinsicElements['div'];

export const AnimatedDigit = ({ className, value, delay = 0, ...props }: AnimatedDigitProps) => (
  <div
    className={classNames(styles.root, className)}
    style={
      {
        ...props.style,
        '--animated-digit-y': `-${(value / 10) * 100}%`,
        '--animated-digit-delay': `${delay}ms`,
      } as CSSProperties
    }
    {...props}>
    <div className={styles.inner}>
      {Array.from({ length: 10 })
        .fill(null)
        .map((each, index) => (
          <div className={styles.digit} key={index}>
            {index}
          </div>
        ))}
    </div>
  </div>
);
